import { render, staticRenderFns } from "./International.vue?vue&type=template&id=454ae14d&"
import script from "./International.vue?vue&type=script&lang=js&"
export * from "./International.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports